import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box, CardLegacy, Dialog, Typography, makeStyles, GRAY } from '@applyboard/ui-components';
import { api_failure } from "../../../../assets/images/Results";
import FooterButton from "../FooterButton";
import { useIsMobile } from "../useIsMobile";
var useStyles = makeStyles({
  card: {
    '&.MuiCard-root': {
      padding: 0,
      margin: 0
    }
  },
  content: {
    padding: '24px 24px 22px 24px'
  },
  heading: {
    fontFamily: 'Montserrat !important',
    fontWeight: 600,
    color: GRAY[5]
  },
  paragraph: {
    color: GRAY[10]
  }
});
function FallbackComponent(_ref) {
  var onExit = _ref.onExit,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? null : _ref$message;
  var classes = useStyles();
  var isMobile = useIsMobile();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var onGoBackClick = function onGoBackClick() {
    setOpen(false);
    onExit();
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: open
  }, /*#__PURE__*/React.createElement(Box, {
    m: "auto",
    p: "6vw"
  }, /*#__PURE__*/React.createElement(CardLegacy, {
    className: classes.card,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.content,
    display: "flex",
    flexDirection: "row"
  }, isMobile && /*#__PURE__*/React.createElement(Box, {
    mr: "16px"
  }, /*#__PURE__*/React.createElement("img", {
    height: "40px",
    width: "40px",
    src: api_failure,
    alt: "" /* Omitted for decorative image */
  })), /*#__PURE__*/React.createElement("div", null, message ? /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    className: classes.paragraph
  }, message) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.heading,
    gutterBottom: true
  }, "Oops! Something went wrong."), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    className: classes.paragraph
  }, "We're working on it and we'll get it fixed as soon as we can.")))), /*#__PURE__*/React.createElement(FooterButton, {
    label: "Go Back",
    onClick: onGoBackClick
  }))));
}
export default FallbackComponent;